import { buildUrl, parseSearchString } from 'lib/url/searchUrlUtils'
import { push, replace } from 'lib/routing/appRouting'
import { PATH_CHANGE } from './actionConstants'
import qs from 'qs'
import { removeRegionCode } from 'lib/string/regionUtils'
import type { AppAction } from './types/ActionTypes'
import { getVisibleLanguageOptions } from 'i18n/util/locale'
import { LabRemoteConfigKeys } from 'constants/lab'
import UrlLocation from 'src/lib/url/UrlLocation'

function getLocaleUrlOptions(state: App.State) {
  const languageOptions = getVisibleLanguageOptions(state.system.features.remoteConfigFlags?.[LabRemoteConfigKeys.languages])
  const currentPathLocale = new UrlLocation(state.router.location.pathname).locale

  return {
    locale: state.geo.locale ?? currentPathLocale,
    languageOptions,
  }
}

export const RESET_SCROLL_STATE: App.LocationState = { scrollTo: { top: 0, left: 0 } }

export function pushWithRegion(
  path: string,
  search?: string,
  locationState?: App.LocationState,
  hash?: string,
): AppAction {
  return (dispatch, getState) => {
    const state = getState()
    const url = buildUrl(path, state.geo.currentRegionCode, search, hash, getLocaleUrlOptions(state))
    dispatch(push(url, locationState))
  }
}

export function replaceWithRegion(path: string, search?: string, hash?: string, locationState?: App.LocationState): AppAction {
  return (dispatch, getState) => {
    const state = getState()
    const url = buildUrl(path, state.geo.currentRegionCode, search, hash, getLocaleUrlOptions(state))
    dispatch(replace(url, locationState))
  }
}

export function pathChange(): AppAction {
  return ({ type: PATH_CHANGE })
}

export function updateSearchString(queryParams: Record<string, unknown>): AppAction {
  return (dispatch, getState) => {
    const state = getState()
    const regionCode = state.geo.currentRegionCode
    const path = removeRegionCode(state.router.location.pathname, regionCode)
    const currentQueryParams = parseSearchString(state.router.location.search)
    const hash = state.router.location.hash
    dispatch(pushWithRegion(
      path,
      qs.stringify({
        ...currentQueryParams,
        ...queryParams,
      }),
      undefined,
      hash,
    ))
  }
}

export function replaceSearchString(queryParams: Record<string, unknown>): AppAction {
  return (dispatch, getState) => {
    const state = getState()
    const regionCode = state.geo.currentRegionCode
    const path = removeRegionCode(state.router.location.pathname, regionCode)
    const currentQueryParams = parseSearchString(state.router.location.search)
    const hash = state.router.location.hash
    dispatch(replaceWithRegion(
      path,
      qs.stringify({
        ...currentQueryParams,
        ...queryParams,
      }),
      hash,
    ))
  }
}
